import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProjectWindowComponent} from './view/project-window/project-window.component';
import {MiscModule} from 'projects/core/src/public-api';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ProjectsListComponent} from './view/projects-list/projects-list.component';

import {SelectButtonModule} from 'primeng/selectbutton';
import {CalendarModule} from 'primeng/calendar';
import {FileUploadModule} from 'primeng/fileupload';
import {ConfirmDialogModule} from 'primeng/confirmdialog';

import {TableModule} from 'primeng/table';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {ProjectMiscModule} from 'projects/app-misc/src/app/modules/project-misc/project-misc.module';
import {MatDialogModule} from '@angular/material/dialog';
import {MatRippleModule} from '@angular/material/core';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {TooltipModule} from 'primeng/tooltip';
import {ClientNfsModule} from '../../view/notification/notification.module';
import {DocuSignModule} from 'projects/app-misc/src/app/modules/docusign/docusign.module';
import {FilesMiscModule} from '../../../../../app-misc/src/app/modules/files-misc/files-misc.module';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [
    ProjectWindowComponent,
    ProjectsListComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    TooltipModule,
    TableModule,
    MatDialogModule,
    MatRippleModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressBarModule,
    SelectButtonModule,
    OverlayPanelModule,
    CalendarModule,
    FileUploadModule,
    MiscModule,
    ConfirmDialogModule,
    ClientNfsModule,
    ProjectMiscModule,
    DocuSignModule,
    FilesMiscModule
  ],
  entryComponents: [
    ProjectWindowComponent
  ]
})
export class DesktopProjectModule {
}
